import React from 'react';
import { ProductBuilderWorkspace } from '../product-builder/ProductBuilderWorkspace';

interface ProductBuilderViewProps {
  selectedTemplateId?: string;
  editingProjectId?: string;
  onBackToTemplates: () => void;
  onAddLog: (module: string, action: string, status: 'SUCCESS' | 'WARNING' | 'DENIED' | 'PENDING_APPROVAL', details: string) => void;
  onAddTaskToWorkSuite?: (title: string, priority: 'URGENT' | 'HIGH' | 'MEDIUM' | 'LOW') => void;
}

export const ProductBuilderView: React.FC<ProductBuilderViewProps> = (props) => {
  return <ProductBuilderWorkspace {...props} />;
};
